import { Messages } from '~src/codegen/Localize';
import { openReactConfirmationDialog } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { ResultHelper } from '~src/httpClient/utils/ResultHelper';
import { DatasourceRevisionsInstance } from '~src/revisionHistoryDatasource/resources/DatasourceRevisions';
import { IDatasourceRevision } from '~src/revisionHistoryDatasource/serverApi/types/IDatasourceRevision';
import { FlowRevisions } from '~src/revisionHistoryFlow/resources/FlowRevisions';
import { FlowRevision } from '~src/revisionHistoryFlow/serverApi/types/FlowRevision';
import { WorkbookRevisionsInstance } from '~src/revisionHistoryWorkbook/resources/WorkbookRevisions';
import { IWorkbookRevision } from '~src/revisionHistoryWorkbook/serverApi/types/IWorkbookRevision';
import { DatasourceContentType, FlowContentType, IContentType, WorkbookContentType } from '~src/ts/models/ContentTypes';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';

import { RevisionHistoryActionContext } from '../interfaces/RevisionHistoryActionContext';
import { IContentRevision } from '../serverApi/types/IContentRevision';


export namespace DeleteRevisionAction {
    export function showDeleteWorkbookRevisionDialog(revision: IWorkbookRevision, context: RevisionHistoryActionContext<any>): Promise<IResult> {
      return showDeleteRevisionDialog(revision, context, WorkbookContentType);
    }

    export function showDeleteDataSourceRevisionDialog(revision: IDatasourceRevision, context:  RevisionHistoryActionContext<any>): Promise<IResult> {
      return showDeleteRevisionDialog(revision, context, DatasourceContentType);
    }

    export function showDeleteFlowRevisionDialog(revision: FlowRevision, context:  RevisionHistoryActionContext<any>): Promise<IResult> {
      return showDeleteRevisionDialog(revision, context, FlowContentType);
    }

    function showDeleteRevisionDialog(revision: IContentRevision, context:  RevisionHistoryActionContext<any>, contentType: IContentType): Promise<IResult> {
      let successText: string;

      switch (contentType) {
        case WorkbookContentType:
          successText = Messages.deleteWorkbookRevisionSuccess();
          break;
        case DatasourceContentType:
          successText = Messages.deleteDataSourceRevisionSuccess();
          break;
        case FlowContentType:
          successText = Messages.deleteFlowRevisionSuccess();
          break;
        default:
          throw new Error(Messages.revisionHistoryUnsupportedContentType());
      }

      const dialogInstance = openReactConfirmationDialog<void, IResult>({
        dialogWidth: TabDialogWidth.width375px,
        title: Messages.deleteMessage(),
        message: Messages.deleteRevisionConfirm(),
        actionName: Messages.deleteMessage(),
        isActionDelete: true,
        paramsForAction: undefined,
        action: () => performDelete(revision, contentType, successText)
      });

      dialogInstance.result.then((result) => deselectDeletedRevision(result, context), ()=>{});
      return Promise.resolve(dialogInstance.result);
    }

    export function performDelete(revision: IContentRevision, contentType: IContentType, successText: string): Promise<IResult> {
      let deleteRequest;
      switch (contentType) {
        case WorkbookContentType:
          deleteRequest = WorkbookRevisionsInstance.del;
          break;
        case DatasourceContentType:
          deleteRequest = DatasourceRevisionsInstance.del;
          break;
        case FlowContentType:
          deleteRequest = FlowRevisions.del;
          break;
        default:
          throw new Error(Messages.revisionHistoryUnsupportedContentType());
      }
      return deleteRequest(revision.id).then(
        (result: IResult) => {
          if (ResultHelper.hasErrors(result)) {
            ToasterService.instance.pop({ type: ToastType.Error, text: Messages.deleteRevisionError() });
          } else {
            ToasterService.instance.pop({ type: ToastType.Info, text: successText });
          }
          return Promise.resolve(result);
        }
      );
    }

    function deselectDeletedRevision(result: IResult, context: RevisionHistoryActionContext<any>) {
      if (!ResultHelper.hasErrors(result)){
        (context as RevisionHistoryActionContext<IContentRevision>).updateState();
      }
    }
}